import { gql } from "apollo-angular";

export const GETALL_EESE_COVERAGE_QUERY = gql`query configuratorAllEeseCoverages($RegBy: String) {
  configuratorAllEeseCoverages(RegBy: $RegBy) {
    Version
    Uid
    ItemNo
    Name
    ModifiedBy
    ModificationTime
    LockedTime
    LockedBy
    CreationTime
    CreatedBy
    Comment
    ApprovedForTestLevel
    ApprovalStatus
  }
}
`

export const GET_EESE_COVERAGE_QUERY = gql`query configuratorEeseCoverageById($Uid: String!) {
  configuratorEeseCoverageById(Uid: $Uid) {
    responseMessages
    returnValue
    success
  }
}
`

export const GET_EESE_COVERAGE_UI_TEMPLATE_QUERY = gql`query configuratorEeseCoverageUiTemplate {
  configuratorEeseCoverageUiTemplate {
    Name
    Category
    DefaultValue
    FieldType
    IsMultiValue
    HasHierarchyValues
    IsReadOnly
    Label
    IsRequired
    Order
    Tooltip
    ValueList
  }
}
`

export const SEARCH_EESE_COVERAGE_QUERY = gql`query configuratorSearchEeseCoverage($EeseCoverage: EeseCoverageInput) {
  configuratorSearchEeseCoverage(EeseCoverage: $EeseCoverage) {
    Version
    Uid
    ItemNo
    Name
    ModifiedBy
    ModificationTime
    LockedTime
    LockedBy
    CreationTime
    CreatedBy
    Comment
    ApprovedForTestLevel
    ApprovalStatus
  }
}
`

export const GET_EESE_COVERAGE_SEARCH_UI_TEMPLATE_QUERY = gql`query configuratorEeseCoverageSearchUiTemplate {
  configuratorEeseCoverageSearchUiTemplate {
    Name
    Category
    DefaultValue
    FieldType
    IsMultiValue
    HasHierarchyValues
    IsReadOnly
    Label
    IsRequired
    Order
    Tooltip
    ValueList
  }
}
`
